// extracted by mini-css-extract-plugin
export default {"sitemapList":"Sitemap_sitemapList__PqQmi","sitemapWrapper":"Sitemap_sitemapWrapper__7+3og"};